/* merchant/types */
import * as t from "io-ts";

function tOptional<T extends t.Mixed>(typeThing: T) {
  return t.union([t.undefined, t.null, typeThing]);
}

const tId = t.union([t.undefined, t.string]);

const ErrorCodec = t.type(
  {
    code: t.string,
    detail: t.string,
    title: t.string,
  },
  "ErrorCodec"
);

const AdditionalDataCodec = t.type({
  Tag: tOptional(t.string),
  Value: tOptional(t.string),
  Encrypted: t.boolean,
});

const ProcMerchantCodec = t.intersection([
  t.type({
    // ProcessorName: t.unknown,
  }),
  t.partial({
    ProcessorName: t.string,
    MID: t.string,
    AdditionalData: t.array(AdditionalDataCodec),
  }),
]);

const SurchargePercentageCodec = t.intersection([
  t.type({
    CardType: t.string,
  }),
  t.partial({
    Percentage: t.number,
  }),
]);

const ScheduleJobCodec = t.intersection([
  t.type({
    cron: tOptional(t.string),
    jobType: tOptional(t.string),
    enabled: t.boolean,
    parameters: tOptional(t.type({
      MID: tOptional(t.string),
    })),
    status: tOptional(t.string),
    timezone: t.string,
  }),
  t.partial({
    lastCompleted: t.string,
    lastExecution: t.string,
    timeSchedule: t.string,
  }),
]);

export type Processor = t.TypeOf<typeof ProcMerchantCodec>;
export type AdditionalData = t.TypeOf<typeof AdditionalDataCodec>;
export type SurchargePercentage = t.TypeOf<typeof SurchargePercentageCodec>;

const ContactCodec = t.intersection([
  t.type({}),
  t.partial({
    First: t.string,
    Last: t.string,
    Mobile: t.number,
    Phone: t.number,
    email: t.string,
    SortNumber: t.number,
  }),
]);

const AttributeCodec = t.intersection([
  t.type({
    Name: t.string,
  }),
  t.partial({
    Address1: t.string,
    Address2: t.string,
    Suburb: t.string,
    State: t.string,
    Postcode: t.string,
    MCC: t.string,
    Note: t.string,
    // MID: tOptional(t.string),
    Processor: t.array(ProcMerchantCodec),
    Contact: t.array(ContactCodec),
    MID: t.string,
    Surcharge: t.boolean,
    SurchargeTip: t.boolean,
    SurchargePercentage: t.array(SurchargePercentageCodec),
    CashOutDailyLimit: t.number,
    CashOutDailyLimitEnabled: t.boolean,
  }),
]);

const DataCodec = t.intersection([
  t.type({
    id: tId,
    type: t.string,
    attributes: AttributeCodec,
  }),
  t.partial({
    createdAt: t.string,
    updatedAt: t.string,
    scheduleJob: ScheduleJobCodec
  }),
]);

export type Data = t.TypeOf<typeof DataCodec>;
export type Error = t.TypeOf<typeof ErrorCodec>;

const MetaCodec = t.type({
  totalObjects: tOptional(t.number),
});
export type Meta = t.TypeOf<typeof MetaCodec>;

export const MerchantCodec = t.type(
  {
    // errors: tOptional(t.union([t.undefined, t.array(ErrorCodec)])),
    errors: tOptional(t.array(ErrorCodec)),
    data: tOptional(t.array(DataCodec)),
    dataAll: tOptional(t.array(DataCodec)),
    meta: tOptional(MetaCodec),
  },
  "MerchantCodec"
);

export type Merchant = t.TypeOf<typeof MerchantCodec>;

export enum MerchantActionTypes {
  FETCH = "@@merchant/FETCH",
  FETCH_ALL = "@@merchant/FETCH_ALL",
  FETCH_SUCCESS = "@@merchant/FETCH_SUCCESS",
  FETCHALL_SUCCESS = "@@merchant/FETCHALL_SUCCESS",
  FETCH_ERROR = "@@merchant/FETCH_ERROR",
  SAVE_REQUEST = "@@merchant/SAVE_REQUEST",
  SAVE_SUCCESS = "@@merchant/SAVE_SUCCESS",
  SAVE_ERROR = "@@merchant/SAVE_ERROR",
  DELETE_REQUEST = "@@merchant/DELETE_REQUEST",
  DELETE_SUCCESS = "@@merchant/DELETE_SUCCESS",
  DELETE_ERROR = "@@merchant/DELETE_ERROR",
  UPDATE_STATE = '@@merchant/UPDATE_STATE",',
  DOWNLOAD_REQUEST = '@@merchant/DOWNLOAD_REQUEST",',
}

export interface MerchantState {
  readonly loading: boolean;
  readonly data: Merchant | undefined;
  readonly dataAll: Merchant | undefined;
  readonly errors?: string;
}
